import { message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { videoSourceService } from '../service/videoSourceService';

interface VideoSourceHandlersProps {
  navigate: NavigateFunction;
}

interface VideoSourceHandlersReturn {
  onClickDeleteButton: (id: number) => Promise<void>;
  onClickTitleButton: (id: number) => void;
  onClickSettingButton: (id: number) => void;
  onClickReloadButton: (id: number) => void;
  handleAddClick: () => void;
}

export const getVideoSourceHandlers = ({
  navigate,
}: VideoSourceHandlersProps): VideoSourceHandlersReturn => {
  const onClickDeleteButton = async (id: number): Promise<void> => {
    // message.info(`You do not have permission to delete video source with id ${id}`);
    const isConfirmed = window.confirm('Are you sure you want to delete the selected items?');
    if (!isConfirmed) return;
    await videoSourceService.delete(id);
    window.location.reload();
  };

  const onClickTitleButton = (id: number): void => {
    navigate(`/video-source/edit/${id}`);
  };

  const onClickSettingButton = (id: number): void => {
    navigate(`/video-source/edit/${id}`);
  };

  const onClickReloadButton = async (id: number): Promise<void> => {
    try {
      const itemCount = await videoSourceService.countMrssItems(id);
      if (itemCount > 200) {
        message.warning(
          `Too many items in the MRSS feed: ${itemCount} items found. (Maximum: 200)
           Please reduce the number of items and try again.`,
          5
        );
        return;
      }
    } catch (error) {
      console.error('Failed to verify the MRSS feed:', error);
      return;
    }

    videoSourceService
      .generate(id)
      .then(() => {
        message.success(
          `Started loading data.
           This may take some time.`,
          5
        );
      })
      .catch(error => {
        console.error('Failed to load data:', error);
      });
  };

  const handleAddClick = (): void => {
    navigate('/video-source/edit');
  };

  return {
    onClickDeleteButton,
    onClickTitleButton,
    onClickSettingButton,
    onClickReloadButton,
    handleAddClick,
  };
};
